const initCartLineItemQty = () => {
  const lineItemQtyEls = document.querySelectorAll('[data-cart-qty]');
  if (!lineItemQtyEls.length) return;

  lineItemQtyEls.forEach((qtyEl) => {
    const input = qtyEl.querySelector('[data-cart-qty-input]');
    const btnIncrease = qtyEl.querySelector('[data-cart-qty-increase]');
    const btnDecrease = qtyEl.querySelector('[data-cart-qty-decrease]');
    const btnUpdate = qtyEl.querySelector('[data-cart-qty-update]');
    if (!input || !btnIncrease || !btnDecrease) return;

    const updateValue = (delta) => {
      const currentValue = Number(input.value) || 1;
      const newValue = currentValue + delta;

      if (newValue >= 1) {
        input.value = newValue;
        btnUpdate && btnUpdate.classList.remove('hidden');
      }
    };

    btnIncrease.addEventListener('click', () => updateValue(1));
    btnDecrease.addEventListener('click', () => updateValue(-1));
  });
};

export default initCartLineItemQty;
